import React from 'react';

import { useFieldBulletinBoardEdit } from '../../services/fieldBulletinBoard/FieldBulletinBoardEditContext';

import { FieldBulletinBoardPublishSettings } from './FieldBulletinBoardPublishSettings';

/**
 * 現場掲示板編集 公開設定
 * @returns { JSX.Element }
 */
export function FieldBulletinBoardPublishSettingsEdit() {
  const {
    getData,
    handleChangeData,
    validateFormItem,
    getFormErrorMessage,
    getUsageEndDate,
  } = useFieldBulletinBoardEdit();

  const formErrorMessage = getFormErrorMessage();
  const data = getData();
  const usageEndDate = getUsageEndDate();

  return (
    <FieldBulletinBoardPublishSettings
      data={data}
      handleChangeData={handleChangeData}
      validateFormItem={validateFormItem}
      formErrorMessage={formErrorMessage}
      usageEndDate={usageEndDate}
    />
  );
}



// WEBPACK FOOTER //
// ./src/components/fieldBulletinBoard/FieldBulletinBoardPublishSettingsEdit.jsx